export const languagesTargetingOptions = [
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1000',
    targetingOptionId: '1000',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'English'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1001',
    targetingOptionId: '1001',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'German'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1002',
    targetingOptionId: '1002',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'French'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1003',
    targetingOptionId: '1003',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Spanish'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1004',
    targetingOptionId: '1004',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Italian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1005',
    targetingOptionId: '1005',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Japanese'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1009',
    targetingOptionId: '1009',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Danish'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1010',
    targetingOptionId: '1010',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Dutch'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1011',
    targetingOptionId: '1011',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Finnish'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1012',
    targetingOptionId: '1012',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Korean'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1013',
    targetingOptionId: '1013',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Norwegian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1014',
    targetingOptionId: '1014',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Portuguese'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1015',
    targetingOptionId: '1015',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Swedish'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1017',
    targetingOptionId: '1017',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Chinese (simplified)'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1018',
    targetingOptionId: '1018',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Chinese (traditional)'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1019',
    targetingOptionId: '1019',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Arabic'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1020',
    targetingOptionId: '1020',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Bulgarian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1021',
    targetingOptionId: '1021',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Czech'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1022',
    targetingOptionId: '1022',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Greek'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1023',
    targetingOptionId: '1023',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Hindi'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1024',
    targetingOptionId: '1024',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Hungarian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1025',
    targetingOptionId: '1025',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Indonesian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1026',
    targetingOptionId: '1026',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Icelandic'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1027',
    targetingOptionId: '1027',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Hebrew'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1028',
    targetingOptionId: '1028',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Latvian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1029',
    targetingOptionId: '1029',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Lithuanian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1030',
    targetingOptionId: '1030',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Polish'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1031',
    targetingOptionId: '1031',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Russian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1032',
    targetingOptionId: '1032',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Romanian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1033',
    targetingOptionId: '1033',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Slovak'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1034',
    targetingOptionId: '1034',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Slovenian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1035',
    targetingOptionId: '1035',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Serbian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1036',
    targetingOptionId: '1036',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Ukrainian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1037',
    targetingOptionId: '1037',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Turkish'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1038',
    targetingOptionId: '1038',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Catalan'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1039',
    targetingOptionId: '1039',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Croatian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1040',
    targetingOptionId: '1040',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Vietnamese'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1041',
    targetingOptionId: '1041',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Urdu'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1042',
    targetingOptionId: '1042',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Filipino'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1043',
    targetingOptionId: '1043',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Estonian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1044',
    targetingOptionId: '1044',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Thai'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1056',
    targetingOptionId: '1056',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Bengali'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1064',
    targetingOptionId: '1064',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Persian'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1072',
    targetingOptionId: '1072',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Gujarati'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1086',
    targetingOptionId: '1086',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Kannada'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1098',
    targetingOptionId: '1098',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Malayalam'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1101',
    targetingOptionId: '1101',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Marathi'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1102',
    targetingOptionId: '1102',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Malay'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1110',
    targetingOptionId: '1110',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Punjabi'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1130',
    targetingOptionId: '1130',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Tamil'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_LANGUAGE/targetingOptions/1131',
    targetingOptionId: '1131',
    targetingType: 'TARGETING_TYPE_LANGUAGE',
    languageDetails: {
      displayName: 'Telugu'
    }
  }
]
